import React from "react"
// import { Link } from "gatsby"
import styled, { css } from 'styled-components'
import { Date, Week } from '../../shared/Date'

import titleSvg from '../../../images/title.svg'
import location from '../../../images/location.svg'

const Wrapper = styled.div`
  // position: relative;
  height: 100vh;
`

const H1 = styled.h1`
  ${({ theme: { font, breakpoints } }) => css`
    font-family: ${font.en};
    // font-size: 40px;
    // font-size: 4.0rem;
    // letter-spacing: 0.2em;
    // margin-bottom: 24px;
    padding: 17.6rem 0 8.0rem;
    width: 32.0rem;
    height: auto;
    img {
      display: block;
      position: relative;
      left: -1.6rem;
      width: 100%;
      height: 100%;
      // max-width: 60vw;
      object-fit: cover;
    }
    @media (min-width: ${breakpoints.md}px) {
      padding: 23.2rem 0 12.0rem;
      width: 32.0rem;
    }
  `}
`
const Place = styled.div`
  ${({ theme: { font, breakpoints } }) => css`
    padding-top: 2.4rem;
    width: 27.2rem;
    @media (min-width: ${breakpoints.md}px) {
      width: 27.2rem;
    }
  `}
`

// const BlockSpan = styled.span`
//   display: block;
//   font-size: 20px;
//   // font-size: 2.0rem;
//   margin-bottom: 30px;
//   &:first-child {
//     margin-bottom: 10px;
//   }
//   &:last-child {
//     margin-top: 20px;
//     margin-bottom: 0;
//     font-size: 4.0rem;
//     font-weight: 500;
//   }
//   span {
//     display: inline-block;
//     margin-bottom: 10px;
//   }
// `

const Top = () => {
  return (
    <Wrapper>
      <H1>
        <img src={titleSvg} alt="多摩美術大学情報デザイン学科情報デザインコース卒業研究制作展" />
        {/* <BlockSpan>多摩美術大学</BlockSpan>
        <BlockSpan><span>情報デザイン学科</span> <span>情報デザインコース</span></BlockSpan>
        卒業研究制作展
        <BlockSpan>2021</BlockSpan> */}
      </H1>
      <Date>3.5<Week> Fri</Week> - 3.7<Week> Sun</Week></Date>
      <Place>
        <img src={location} alt="横浜赤レンガ倉庫１号館" />
      </Place>
      {/* <PlaceLinkButton>横浜赤レンガ１号館</PlaceLinkButton> */}
    </Wrapper>
  )
}

export default Top
